module.exports = __webpack_public_path__ + "static/media/feature-compare@2x.f044331b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/feature-compare@2x.png
// module id = 176
// module chunks = 0